import React, { useEffect } from "react";
import Loader from "../components/Loader";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import Newsletter from "../components/Newsletter";
import Breadcrumbs from "../components/Breadcrumbs";
import parse from "html-react-parser";

export default function DuroRewards({ setHeader }) {
  const { t } = useTranslation();

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 1) {
        setHeader(true);
      } else {
        setHeader(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, [setHeader]);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          {t("header.rewards.pageTitle")} - DURŌ Niche perfumery - Niche parfimerija
        </title>
        <meta name="description" content={t("header.rewards.metaDescription")} />
        <meta
          name="keywords"
          content="durō, duro, loyalty, rewards, niche perfumery, niche parfimerija, beograd, parfimerija, galerija"
        />
        <meta name="author" content="intellect.se" />
        <meta httpEquiv="x-ua-compatible" content="ie=edge" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta property="og:image:height" content="1200" />
        <meta property="og:image:width" content="630" />
        <meta property="og:title" content="DURŌ | Niche perfumery" />
        <meta
          property="og:description"
          content="DURŌ, where the art of niche perfumery meets ultimate luxury. We represent 30 of the most sought-after artisan perfume houses and offer a one-of-a-kind immersive experience in our boutique."
        />
        <meta property="og:url" content="https://www.parfimerija-duro.rs/" />
        <meta
          property="og:image"
          content="https://www.parfimerija-duro.rs/assets/images/favicon/og-image.png"
        />
      </Helmet>
      <Loader />
      <div className="main-content">
        <div className="rs-breadcrumbs img3">
          <div className="container">
            <div className="breadcrumbs-inner">
              <h1 className="page-title">{t("rewards.title")}</h1>
            </div>
          </div>
        </div>
        <Breadcrumbs bg="light" />

        <div className="rs-faq gray-bg4 pt-40 md-pt-40">
          <div className="container">
            <div className="rs-privacy-policy pt-10 md-pt-10">
              {/* Overview / Intro */}
              <div className="privacy-wrap pb-60 md-pb-60">
                <div className="privacy-content">
                  <div className="desc">{parse(t("rewards.overview"))}</div>
                </div>
              </div>
              {/* 1. General Terms */}
              <div className="privacy-wrap pb-60 md-pb-60">
                <div className="sec-title mb-50">
                  <h2 className="title title2" id="general-terms">
                    {t("rewards.sections.generalTerms.title")}
                  </h2>
                </div>
                <div className="privacy-content">
                  <h3>{t("rewards.sections.generalTerms.subjectAndScope.title")}</h3>
                  {(() => {
                    const c = t("rewards.sections.generalTerms.subjectAndScope.content");
                    return c && c.trim().length > 0 ? <p>{c}</p> : null;
                  })()}

                  <h3>{t("rewards.sections.generalTerms.definitions.title")}</h3>
                  <ul className="check-list">
                    <li>{t("rewards.sections.generalTerms.definitions.li1")}</li>
                    <li>{t("rewards.sections.generalTerms.definitions.li2")}</li>
                    <li>{t("rewards.sections.generalTerms.definitions.li3")}</li>
                    <li>{t("rewards.sections.generalTerms.definitions.li4")}</li>
                    <li>{t("rewards.sections.generalTerms.definitions.li5")}</li>
                    <li>{t("rewards.sections.generalTerms.definitions.li6")}</li>
                  </ul>

                  <h3>{t("rewards.sections.generalTerms.joining.title")}</h3>
                  <ul className="check-list">
                    <li>{t("rewards.sections.generalTerms.joining.li1")}</li>
                    <li>{t("rewards.sections.generalTerms.joining.li2")}</li>
                    <li>{t("rewards.sections.generalTerms.joining.li3")}</li>
                  </ul>

                  <h3>{t("rewards.sections.generalTerms.membershipNumber.title")}</h3>
                  <ul className="check-list">
                    <li>{t("rewards.sections.generalTerms.membershipNumber.li1")}</li>
                    <li>{t("rewards.sections.generalTerms.membershipNumber.li2")}</li>
                    <li>{t("rewards.sections.generalTerms.membershipNumber.li3")}</li>
                  </ul>

                  <h3>{t("rewards.sections.generalTerms.benefits.title")}</h3>
                  <ul className="check-list">
                    <li>{t("rewards.sections.generalTerms.benefits.li1")}</li>
                    <li>{t("rewards.sections.generalTerms.benefits.li2")}</li>
                    <li>{t("rewards.sections.generalTerms.benefits.li3")}</li>
                  </ul>

                  <h3>{t("rewards.sections.generalTerms.nonTransfer.title")}</h3>
                  <ul className="check-list">
                    <li>{t("rewards.sections.generalTerms.nonTransfer.li1")}</li>
                    <li>{t("rewards.sections.generalTerms.nonTransfer.li2")}</li>
                  </ul>

                  <h3>{t("rewards.sections.generalTerms.termination.title")}</h3>
                  <ul className="check-list">
                    <li>{t("rewards.sections.generalTerms.termination.li1")}</li>
                    <li>{t("rewards.sections.generalTerms.termination.li2")}</li>
                  </ul>

                  <h3>{t("rewards.sections.generalTerms.complaints.title")}</h3>
                  <ul className="check-list">
                    <li>{t("rewards.sections.generalTerms.complaints.li1")}</li>
                    <li>{t("rewards.sections.generalTerms.complaints.li2")}</li>
                  </ul>

                  <h3>{t("rewards.sections.generalTerms.changes.title")}</h3>
                  <ul className="check-list">
                    <li>{t("rewards.sections.generalTerms.changes.li1")}</li>
                    <li>{t("rewards.sections.generalTerms.changes.li2")}</li>
                  </ul>
                </div>
              </div>

              {/* 2. Card */}
              <div className="privacy-wrap pb-60 md-pb-60">
                <div className="sec-title mb-50">
                  <h2 className="title title2">
                    {t("rewards.sections.card.title")}
                  </h2>
                </div>
                <div className="privacy-content">
                  <h3>{t("rewards.sections.card.issuing.title")}</h3>
                  <ul className="check-list">
                    <li>{t("rewards.sections.card.issuing.li1")}</li>
                    <li>{t("rewards.sections.card.issuing.li2")}</li>
                    <li>{t("rewards.sections.card.issuing.li3")}</li>
                    <li>{t("rewards.sections.card.issuing.li4")}</li>
                  </ul>

                  <h3>{t("rewards.sections.card.usage.title")}</h3>
                  <ul className="check-list">
                    <li>{t("rewards.sections.card.usage.li1")}</li>
                    <li>{t("rewards.sections.card.usage.li2")}</li>
                    <li>{t("rewards.sections.card.usage.li3")}</li>
                  </ul>

                  <h3>{t("rewards.sections.card.discount.title")}</h3>
                  <ul className="check-list">
                    <li>{t("rewards.sections.card.discount.li1")}</li>
                    <li>{t("rewards.sections.card.discount.li2")}</li>
                    <li>{t("rewards.sections.card.discount.li3")}</li>
                    <li>{t("rewards.sections.card.discount.li4")}</li>
                  </ul>

                  <h3>{t("rewards.sections.card.loss.title")}</h3>
                  <ul className="check-list">
                    <li>{t("rewards.sections.card.loss.li1")}</li>
                    <li>{t("rewards.sections.card.loss.li2")}</li>
                    <li>{t("rewards.sections.card.loss.li3")}</li>
                  </ul>
                </div>
              </div>

              {/* 3. Rights */}
              <div className="privacy-wrap pb-60 md-pb-60">
                <div className="sec-title mb-50">
                  <h2 className="title title2">
                    {t("rewards.sections.rights.title")}
                  </h2>
                </div>
                <div className="privacy-content">
                  <h3>{t("rewards.sections.rights.memberDuties.title")}</h3>
                  <ul className="check-list">
                    <li>{t("rewards.sections.rights.memberDuties.li1")}</li>
                    <li>{t("rewards.sections.rights.memberDuties.li2")}</li>
                    <li>{t("rewards.sections.rights.memberDuties.li3")}</li>
                    <li>{t("rewards.sections.rights.memberDuties.li4")}</li>
                  </ul>

                  <h3>{t("rewards.sections.rights.memberRights.title")}</h3>
                  <ul className="check-list">
                    <li>{t("rewards.sections.rights.memberRights.li1")}</li>
                    <li>{t("rewards.sections.rights.memberRights.li2")}</li>
                    <li>{t("rewards.sections.rights.memberRights.li3")}</li>
                    <li>{t("rewards.sections.rights.memberRights.li4")}</li>
                  </ul>

                  <h3>{t("rewards.sections.rights.orgObligations.title")}</h3>
                  <ul className="check-list">
                    <li>{t("rewards.sections.rights.orgObligations.li1")}</li>
                    <li>{t("rewards.sections.rights.orgObligations.li2")}</li>
                    <li>{t("rewards.sections.rights.orgObligations.li3")}</li>
                    <li>{t("rewards.sections.rights.orgObligations.li4")}</li>
                  </ul>

                  <h3>{t("rewards.sections.rights.orgRights.title")}</h3>
                  <ul className="check-list">
                    <li>{t("rewards.sections.rights.orgRights.li1")}</li>
                    <li>{t("rewards.sections.rights.orgRights.li2")}</li>
                    <li>{t("rewards.sections.rights.orgRights.li3")}</li>
                  </ul>
                </div>
              </div>

              {/* 4. Privacy */}
              <div className="privacy-wrap pb-60 md-pb-60">
                <div className="sec-title mb-50">
                  <h2 className="title title2" id="privacy-policy">
                    {t("rewards.sections.privacy.title")}
                  </h2>
                </div>
                <div className="privacy-content">
                  <h3>{t("rewards.sections.privacy.controller.title")}</h3>
                  <p>{t("rewards.sections.privacy.controller.content")}</p>

                  <h3>{t("rewards.sections.privacy.dataProcessed.title")}</h3>
                  <ul className="check-list">
                    <li>{t("rewards.sections.privacy.dataProcessed.li1")}</li>
                    <li>{t("rewards.sections.privacy.dataProcessed.li2")}</li>
                    <li>{t("rewards.sections.privacy.dataProcessed.li3")}</li>
                    <li>{t("rewards.sections.privacy.dataProcessed.li4")}</li>
                    <li>{t("rewards.sections.privacy.dataProcessed.li5")}</li>
                  </ul>

                  <h3>{t("rewards.sections.privacy.legalBasis.title")}</h3>
                  <ul className="check-list">
                    <li>{t("rewards.sections.privacy.legalBasis.li1")}</li>
                    <li>{t("rewards.sections.privacy.legalBasis.li2")}</li>
                    <li>{t("rewards.sections.privacy.legalBasis.li3")}</li>
                    <li>{t("rewards.sections.privacy.legalBasis.li4")}</li>
                  </ul>

                  <h3>{t("rewards.sections.privacy.retention.title")}</h3>
                  <ul className="check-list">
                    <li>{t("rewards.sections.privacy.retention.li1")}</li>
                  </ul>

                  <h3>{t("rewards.sections.privacy.recipients.title")}</h3>
                  <ul className="check-list">
                    <li>{t("rewards.sections.privacy.recipients.li1")}</li>
                  </ul>

                  <h3>{t("rewards.sections.privacy.transfers.title")}</h3>
                  <ul className="check-list">
                    <li>{t("rewards.sections.privacy.transfers.li1")}</li>
                  </ul>

                  <h3>{t("rewards.sections.privacy.yourRights.title")}</h3>
                  <p>{t("rewards.sections.privacy.yourRights.content")}</p>

                  <h3>{t("rewards.sections.privacy.security.title")}</h3>
                  <ul className="check-list">
                    <li>{t("rewards.sections.privacy.security.li1")}</li>
                  </ul>

                  <h3>{t("rewards.sections.privacy.policyChanges.title")}</h3>
                  <ul className="check-list">
                    <li>{t("rewards.sections.privacy.policyChanges.li1")}</li>
                  </ul>

                  <h3>{t("rewards.sections.privacy.effectiveDate.title")}</h3>
                  <ul className="check-list">
                    <li>{t("rewards.sections.privacy.effectiveDate.li1")}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="rs-newsletter style1 pt-90 md-pt-60 mb--65">
            <Newsletter />
          </div>
        </div>
      </div>
    </>
  );
}
